import React from 'react';
import { List } from 'antd';
import { PartitionOutlined } from '@ant-design/icons';
import IconText from './IconText';

const RankingListItemMeta = ({ routePath, rankingListItem }) => {
  const poolName = rankingListItem.pool?.value
    ? rankingListItem.pool.value
    : rankingListItem.pool_name || 'No Name';
  const href = `${routePath}/${rankingListItem.author_email}/${rankingListItem.run_id}`;
  const jobProfiles = rankingListItem.job_profile
    ? rankingListItem.job_profile
    : rankingListItem.jds.map((jd) => jd.PK).join(', ') || 'No Job Profile';
  return (
    <List.Item.Meta
      title={
        <a href={href} target="_blank" rel="noopener noreferrer">
          {poolName}
        </a>
      }
      description={[
        <IconText
          icon={PartitionOutlined}
          text={jobProfiles}
          key="description"
        />,
      ]}
    />
  );
};

export default RankingListItemMeta;
